import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import { resourceApi } from '../utils/fetchUtil';
import { getDirections } from '../actions/shopActions';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import ActionMap from 'material-ui/svg-icons/maps/place';
import ActionClose from 'material-ui/svg-icons/navigation/close';
import ActionDirections from 'material-ui/svg-icons/maps/directions';
import Divider from 'material-ui/Divider';
import {Card, CardActions, CardHeader,  CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import ProviderCard from '../Components/ProviderCard';
import ProviderDocDetails from '../Components/ProviderDocDetails';
import Dialog from 'material-ui/Dialog';
import {logDocDetailsClick}  from '../actions/logActions';


class ProviderListMini extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
            view: 'list',
            fetching: false,
            provider: {},
            cost: 0,
            selectedProvider: {},
            markers: [],
            open: false,
            openDocDetails:false,
            latitude: 0,
            longitude: 0
        };

        this.getDirections = this.getDirections.bind(this);
        this.handleOpenMap = this.handleOpenMap.bind(this);
        this.handleOpenDocDetails = this.handleOpenDocDetails.bind(this);
        
    }

     getDirections(provider) {
        getDirections(provider.Address);
    }

    handleOpenDocDetails = (provider) => {
        
        this.setState({selectedProvider: provider});

        this.loadDocDetails(provider);

        this.setState({openDocDetails: true});
    };

     loadDocDetails(provider) {

        var self = this;

         self.setState({fetching: true});

        let config = {
            method: 'get',
            url: `provider/${provider.NPI}/docdetail`
        };

        resourceApi(config)
            .then(function (response) {
                console.log(response);
                
                self.setState({ providerDetails: response.data });

                self.setState({fetching: false});
            })
            .catch(function (error) {
                console.log(error);
                self.setState({fetching: false});
            });
    }


    handleOpenMap = (lat, lng) => {
        this.setState({Latitude: lat});
        this.setState({Longitude: lng});
         this.setState({ markers : [{
                position: { lat: lat, lng: lng}
            }]
        });

        this.setState({openMap: true});
    };

    handleClose = () => {
         this.setState({openMap: false, openRatings: false, openExplain: false, openDocDetails: false});
    };

    selectProvider = (providerId) => {
        //hashHistory.push(`/shop/confirm/${facilityId}/view/${cost}/${distance}`);
        this.props.selectProvider(providerId);
    }

    render() {

            
        const actions = [
            <FlatButton
                label="Close"
                labelPosition="after"
                icon={ <ActionClose />}
                primary={true}
                onClick={this.handleClose}
            />
        ];
        var dasResults = this.props.providers.map((provider, index) => 
        <div >
            <Card style={{boxShadow:'none'}}>
                <CardHeader 
                    title={<h5>{provider.Name}</h5>}     
                    actAsExpander={true}
                    showExpandableButton={true} 
                >
                 
                 </CardHeader>
                 <CardText expandable={true}>
                      <div style={{marginTop:-15}} >
                     <h5>Address</h5>
                     <span style={{fontSize:'14px'}}>{ provider.Address } </span>
                     </div>
                    <br />
                  
                   
                      <CardActions style={{padding:0}}>
                        <FlatButton
                            label="Map This"
                            labelPosition="after"
                            primary={true}
                            style={{margin:0}}
                            icon={<ActionMap />} 
                            onClick={ () => this.handleOpenMap(provider.Latitude, provider.Longitude) }
                        />
                        <FlatButton
                            label="Get Directions"
                            labelPosition="after"
                            primary={true}
                            style={{margin:0}}
                            icon={<ActionDirections />} 
                            onClick={ () => this.getDirections(provider) }
                        />

                    </CardActions>
 <br />
                    <RaisedButton label="Doc Info" labelPosition="after" onClick={ () => this.handleOpenDocDetails(provider)} default={true} style={{ width: '48%'}} />
                    <RaisedButton label="Next Step" labelPosition="after" onClick={() => this.selectProvider(provider.ProviderID)} primary={true} style={{ marginLeft:10, width: '48%'}} />
                    <br />
 </CardText>
                </Card>
                 {((index + 1) !== this.props.providers.length) && (
                    <Divider />
                )}
            </div>
        );

        return (
            <div>
                {(this.state.view === 'list') && (
                    <div>
                        { dasResults }
                    </div>
                )}

                {(this.state.view === 'provider') && (
                    <div>
                        {(this.state.fetching) && (
                            <div className="loader" >
                                <CircularProgress />
                            </div>
                        )}

                        {(!this.state.fetching) && (
                            <ProviderCard provider={this.state.provider} cost={this.state.cost} requireDocAndFacility={this.props.requireDocAndFacility} />
                        )}
                        
                    </div>
                )}

                
                <Dialog actions={actions} open={this.state.openDocDetails} onRequestClose={this.handleClose} >
                    <div>
                        {(this.state.fetching) && (
                            <div className="loader" >
                                <CircularProgress />
                            </div>
                        )}

                        {(!this.state.fetching) && (
                            <div>
                                {(this.state.providerDetails) && (
                                    <ProviderDocDetails details={this.state.providerDetails} />
                                )}

                                {(!this.state.providerDetails) && (
                                    <h5>We we're unable to locate this provider's information. </h5>
                                )}
                            </div>
                        )}
                    </div>
                </Dialog>

                                    
                 


            </div>
        );
    }
};

const mapDispatchToProps = (dispatch) => {
  return {
    logDocDetailsClick: (sctp, term) => {
      dispatch(logDocDetailsClick(sctp, term))
    }
  }
}

const mapStateToProps = (state) => ({
    selectedSearchResult: state.thisApp.searchResults,
    member: state.thisApp.auth.member
})


export default connect(
      mapStateToProps,
  mapDispatchToProps
)(ProviderListMini)



// WEBPACK FOOTER //
// ./src/Components/ProviderListMini.js